var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 81,
    height: 82,
    viewBox: "0 0 71.871 79.0963",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_47_924)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.239 68.3427H50.5892V51.4688C50.5892 47.4447 50.5183 42.2668 45.05 42.2668C39.5038 42.2668 38.6538 46.6492 38.6538 51.1786V68.3427H28.0075V33.6417H38.2323V38.3825H38.374C40.46 34.7776 44.3346 32.6241 48.4606 32.7781C59.2556 32.7781 61.2425 39.9627 61.2425 49.3045L61.239 68.3427ZM15.9906 28.8974C12.5765 28.8974 9.81042 26.0988 9.81042 22.6445C9.81042 19.1901 12.5765 16.3916 15.9906 16.3916C19.4048 16.3916 22.1708 19.1901 22.1708 22.6445C22.1708 26.0988 19.4048 28.8974 15.9906 28.8974ZM21.3138 68.3427H10.6533V33.6417H21.3138V68.3427ZM66.5479 6.38689H5.30188C2.40833 6.35464 0.0354167 8.70172 0 11.6293V73.8503C0.0354167 76.7815 2.40833 79.1285 5.30188 79.0963H66.5479C69.4486 79.1321 71.8321 76.7851 71.871 73.8503V11.6257C71.8286 8.69097 69.445 6.34389 66.5479 6.3833",
    fill: "#000000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_47_924"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 71.871,
    height: 79.0963,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedinIcon.5b9d845fd45943bcccb51be5ce79c327.svg";
export { ForwardRef as ReactComponent };